module.exports = __webpack_public_path__ + "img/approve-list1.8963ca77.png";